import styles from '@/admin/components/AdminSpinner.module.scss';

export const AdminSpinner = () => <div className={styles.spinner} />;
